export default __webpack_public_path__ + "static/media/discipline-social-sciences.eba64505.svg";